module.exports = __webpack_public_path__ + "static/media/SCRIPT_InteractingWithCourtsDigitally(1A)_1609253874951.d85c19e4.docx";